import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-container">
      <h1>About SponsorBoat</h1>
      
      <div className="about-content">
        <div className="about-section">
          <h2>Our Mission</h2>
          <p>
            SponsorBoat is dedicated to connecting content creators with brand sponsorship opportunities. 
            We provide a practical discovery platform where YouTube channels, Instagram accounts, and blogs
            can be found by potential sponsors looking for relevant, high-quality partnerships.
          </p>
        </div>

        <div className="about-section">
          <h2>Built for Creators and Sponsors</h2>
          <p>
            Creators often have the audience and expertise brands need, but finding the right partnership can
            be difficult. SponsorBoat gives creators a place to present their platform, audience size, niche,
            location, and contact details in one clear profile. Sponsors can explore different channels and
            content categories, compare opportunities, and reach out directly when there is a strong fit.
          </p>
        </div>

        <div className="about-section">
          <h2>What We Offer</h2>
          <ul className="features-list">
            <li>Browse and filter YouTube channels by subscriber count</li>
            <li>Discover Instagram accounts by follower count</li>
            <li>Find blogs organized by monthly views</li>
            <li>Filter opportunities by niche and location</li>
            <li>Share profile details, photos, and contact information</li>
            <li>Build direct relationships between brands and creators</li>
          </ul>
        </div>

        <div className="about-section">
          <h2>How Sponsorship Discovery Works</h2>
          <p>
            Sponsors can browse approved creator listings across multiple platforms and use audience metrics,
            niche, and location to narrow their search. When a listing matches a campaign, the sponsor can use
            the provided contact information to start a conversation about goals, deliverables, timing, and
            compensation. SponsorBoat helps make the introduction; the creator and sponsor decide together
            whether and how to work together.
          </p>
        </div>

        <div className="about-section">
          <h2>How to Get Started</h2>
          <ol className="steps-list">
            <li>Visit the Submission Form page</li>
            <li>Choose YouTube, Instagram, or Blog</li>
            <li>Add accurate audience details, niche, location, links, and contact information</li>
            <li>Submit your listing for review</li>
            <li>Once approved, make your profile available to relevant sponsors</li>
          </ol>
        </div>

        <div className="about-section">
          <h2>Our Approach</h2>
          <p>
            We believe useful sponsorships start with relevance and transparency. Clear creator information
            helps sponsors find better matches, while accurate profiles help creators attract campaigns that
            suit their audience. We encourage both sides to discuss expectations openly and to confirm campaign
            terms before beginning any work.
          </p>
        </div>

        <div className="about-section">
          <h2>Contact Us</h2>
          <p>Have questions? We'd love to hear from you! Please visit our Contact page or reach out directly.</p>
        </div>
      </div>
    </div>
  );
}

export default About;
